<!--
  ~ Copyright (c) 2022. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="windowboundcontainer" #windowboundcontainer>
  <div *ngFor="let wnd of _windows">
    <window [handle]="wnd.handle" [manager]="manager" [component]="wnd.componentType" [inputs]="wnd.inputs"></window>
  </div>
</div>
